import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'aw-section-header',
  standalone: true,
  templateUrl: './section-header.component.html',
})
export class SectionHeaderComponent {
  @HostBinding('class') hostClass: string = 'w-full';
}
